// Website zusammenstellen: Paket-Reiter, Beispielbild je Branche, Extras mit Summe, Bestellen in einem Schritt.
(() => {
  const init = (root) => {
    if (root.__bk) return;
    root.__bk = true;
    const form = root.querySelector('[data-bk-form]');
    const pakete = [...root.querySelectorAll('[data-bk-paket]')];
    const branchen = [...root.querySelectorAll('[data-bk-branche]')];
    const extras = [...root.querySelectorAll('[data-bk-extra]')];
    const panels = [...root.querySelectorAll('[data-bk-panel]')];
    const bilder = [...root.querySelectorAll('[data-bk-demo]')];
    const caption = root.querySelector('[data-bk-caption]');
    const total = root.querySelector('[data-bk-total]');
    const message = root.querySelector('[data-bk-message]');
    const currency = root.dataset.currency || 'EUR';
    const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
    const current = () => pakete.find((p) => p.checked) || pakete[0];
    const showMessage = (text) => { message.textContent = text; message.hidden = !text; };

    const update = () => {
      const paket = current();
      const branche = branchen.find((b) => b.checked);
      const demo = branche && branche.dataset.demo && branche.dataset.demo !== 'none' ? branche.dataset.demo : paket.dataset.demo;
      bilder.forEach((el) => {
        const an = el.dataset.bkDemo === demo;
        el.classList.toggle('is-on', an);
        // nur das sichtbare Video läuft, und nur mit Bewegung (sonst bleibt das Standbild)
        if (el.tagName !== 'VIDEO') return;
        if (an && document.documentElement.classList.contains('motion')) { el.preload = 'auto'; el.play().catch(() => {}); } else el.pause();
      });
      if (caption) {
        const own = branche && branche.dataset.demo !== 'none' ? branche.dataset.caption : '';
        caption.textContent = own || `Beispielseite im Paket ${paket.dataset.title}`;
      }
      const index = pakete.indexOf(paket);
      panels.forEach((panel) => (panel.hidden = Number(panel.dataset.bkPanel) !== index));
      const next = pakete[index + 1];
      const upgrade = panels[index] && panels[index].querySelector('[data-bk-upgrade]');
      if (upgrade) {
        upgrade.hidden = !next;
        if (next) {
          const diff = Number(next.dataset.price) - Number(paket.dataset.price);
          upgrade.innerHTML = '';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'link-line';
          button.textContent = `Upgrade auf ${next.dataset.title}: +${money(diff)}`;
          button.addEventListener('click', () => { next.checked = true; update(); });
          upgrade.appendChild(button);
        }
      }
      root.querySelectorAll('.bk__tab').forEach((tab, i) => tab.classList.toggle('is-on', i === index));
      const sum = Number(paket.dataset.price) + extras.filter((e) => e.checked).reduce((a, e) => a + Number(e.dataset.price), 0);
      total.textContent = money(sum);
    };

    // Branche abwählen (nochmal klicken): theme.js (Chips mit Einzelauswahl), meldet sich hier als change
    form.addEventListener('change', () => { showMessage(''); update(); });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const name = form.elements['Website-Name'];
      const branche = branchen.find((b) => b.checked);
      const genau = form.elements['Branche genau'];
      if (!branche && !genau.value.trim()) { genau.focus(); return showMessage('Bitte wählen Sie Ihre Branche oder schreiben Sie sie in das Feld darunter.'); }
      if (!name.value.trim()) { name.focus(); return showMessage('Bitte geben Sie an, wie Ihre Website heißen soll.'); }
      const termin = form.querySelector('[data-wt-datum]');
      if (!termin.checkValidity()) { termin.focus(); return showMessage(termin.validationMessage); }
      const consent = form.elements['properties[Zustimmung zum Leistungsbeginn]'];
      if (!consent.checked) { consent.focus(); return showMessage('Bitte bestätigen Sie den Beginn der Arbeit vor Ablauf der Widerrufsfrist.'); }
      const properties = {
        Branche: branche ? branche.value : 'eigene Angabe',
        'Website-Name': name.value.trim(),
        Wunschtermin: form.elements['properties[Wunschtermin]'].value,
        'Texte und Fotos': form.elements['Texte und Fotos'].value,
        'Zustimmung zum Leistungsbeginn': consent.value,
      };
      if (genau.value.trim()) properties['Branche (eigene Angabe)'] = genau.value.trim();
      if (form.elements.Farbwunsch.value.trim()) properties.Farbwunsch = form.elements.Farbwunsch.value.trim();
      const items = [{ id: Number(current().dataset.id), quantity: 1, properties }, ...extras.filter((e) => e.checked).map((e) => ({ id: Number(e.dataset.id), quantity: 1 }))];
      const button = form.querySelector('.bk__bestellen');
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) throw new Error(String(response.status));
        window.location.href = root.dataset.cartUrl || '/cart';
      } catch (error) {
        button.disabled = false;
        showMessage('Das hat nicht geklappt. Bitte versuchen Sie es noch einmal oder schreiben Sie uns über die Kontaktseite.');
      }
    });
    update();
  };
  const start = (scope) => scope.querySelectorAll('[data-baukasten]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => start(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
})();
